import React from "react";
import PropTypes from "prop-types";
import { Modal, Table, Button, Tag, Space } from "antd";
import { DownloadOutlined } from "@ant-design/icons";

const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

// Version history for a single template. Newest/current first (backend already
// orders it that way). No "make current" action per handoff, only Download.
export default function VersionHistoryModal({
  open,
  title,
  loading,
  versions,
  onClose,
  onDownload,
}) {
  const columns = [
    {
      title: "Version",
      key: "version",
      render: (_, record) => (
        <Space size={6}>
          <Tag color={record.isCurrent ? "green" : "default"}>v{record.version}</Tag>
          {record.isCurrent && (
            <span style={{ color: "#15794a", fontSize: 12, fontWeight: 600 }}>Current</span>
          )}
        </Space>
      ),
    },
    {
      title: "File",
      dataIndex: "originalFileName",
      key: "originalFileName",
      render: (name) => name || <span style={{ color: "#bbb" }}>-</span>,
    },
    {
      title: "Effective From",
      dataIndex: "effectiveFrom",
      key: "effectiveFrom",
      render: formatDateTime,
    },
    {
      title: "Retired On",
      dataIndex: "retiredOn",
      key: "retiredOn",
      render: (value) => (value ? formatDateTime(value) : <span style={{ color: "#bbb" }}>-</span>),
    },
    {
      title: "",
      key: "download",
      align: "right",
      render: (_, record) => (
        <Button size="small" icon={<DownloadOutlined />} onClick={() => onDownload(record)}>
          Download
        </Button>
      ),
    },
  ];

  return (
    <Modal
      title={`Version History${title ? ` - ${title}` : ""}`}
      open={open}
      onCancel={onClose}
      footer={<Button onClick={onClose}>Close</Button>}
      width={720}
      zIndex={2000}
    >
      <Table
        rowKey="hiringDocumentTemplateId"
        columns={columns}
        dataSource={versions}
        loading={loading}
        pagination={false}
        size="small"
        scroll={{ x: 600 }}
      />
    </Modal>
  );
}

VersionHistoryModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  loading: PropTypes.bool,
  versions: PropTypes.array,
  onClose: PropTypes.func,
  onDownload: PropTypes.func,
};
